import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';
import { ActivatedRoute } from '@angular/router';
import { ProductGroupService } from '../product-group.service';

@Component({
  selector: 'app-product-group-register',
  templateUrl: './product-group-register.component.html',
  styleUrls: ['./product-group-register.component.scss']
})

export class ProductGroupRegisterComponent {
  product_group_register_form: FormGroup;
  action: 'register' | 'update' = null;

  constructor(private formBuilder: FormBuilder, private http: HttpService,
              private global: GlobalService, private productGroupService: ProductGroupService, private activatedRoute: ActivatedRoute) {
    this.product_group_register_form = this.formBuilder.group({
      id: [null, Validators.compose([])],
      name: [null, Validators.compose([Validators.required])]
    });

    if (this.productGroupService.get_product_group_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.productGroupService.get_product_group_data);
    }

    this.productGroupService.productGroupUpdate.subscribe((zone) => {
      if (zone === null) {
        this.action = 'register';
        this.product_group_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(zone);
      }
    });
  }

  registerProductGroup() {
    this.http.saveProductGroup(this.product_group_register_form.value).subscribe((data) => {
      this.global.showSnakeBar(data['message']);
      this.productGroupService.downloadProductGroup.emit(true);
    }, (error) => {
      console.log(error);
    });
  }

  setupUpdateForm(product_group) {
    this.product_group_register_form.controls['id'].setValue(product_group['id']);
    this.product_group_register_form.controls['name'].setValue(product_group['name']);
  }
}
